import React from 'react';
import UserDashboard from '../components/dashboard/UserDashboard';

const UserDashboardPage = () => {
  return <UserDashboard />;
};

export default UserDashboardPage;

